
import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import AreaHero from '../components/AreaHero';
import AreaServices from '../components/AreaServices';
import AreaTestimonials from '../components/AreaTestimonials';
import AreaCTA from '../components/AreaCTA';
import { useSEO, generateAreaPageSchema, generateBreadcrumbSchema } from '../../../utils/seo';

export default function RickmansworthPage() {
  const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'Painters & Decorators Rickmansworth Hertfordshire | Brushour',
    description: 'Expert painting and decorating services in Rickmansworth, Hertfordshire. Covering Rickmansworth Town, Mill End, and West Hyde. Fully insured, 18+ years experience. Free quotes available.',
    keywords: 'painters Rickmansworth, decorators Rickmansworth Hertfordshire, painting services Rickmansworth, Rickmansworth painters decorators, decorating Mill End',
    canonical: `${SITE_URL}/areas/rickmansworth`,
    schema: [
      generateAreaPageSchema('Rickmansworth', 'Hertfordshire', 'rickmansworth', 51.6398, -0.4707, 'WD3'),
      generateBreadcrumbSchema([
        { name: 'Home', url: SITE_URL },
        { name: 'Areas', url: `${SITE_URL}/areas` },
        { name: 'Rickmansworth', url: `${SITE_URL}/areas/rickmansworth` },
      ]),
    ],
  });

  const areaData = {
    name: 'Rickmansworth',
    region: 'Hertfordshire',
    description: 'Expert painting and decorating services in Rickmansworth. From residential properties to commercial spaces, we deliver exceptional results with attention to detail and professional craftsmanship throughout Rickmansworth and surrounding areas.',
    heroImage: 'https://public.readdy.ai/ai/img_res/d341b6cbc9ed7521b776ab7c317695d9.jpg',
    serviceAreas: ['Rickmansworth Town', 'Mill End', 'West Hyde', 'Batchworth'],
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <AreaHero data={areaData} />
      <AreaServices area="Rickmansworth" />
      <AreaTestimonials area="Rickmansworth" />
      <AreaCTA area="Rickmansworth" />
      <Footer />
    </div>
  );
}
